import { motion } from 'framer-motion';
import { H2, BodyLarge } from '../ui/Typography';

export default function VideoSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <H2 className="text-primary mb-4">Discover RentFi</H2>
          <BodyLarge className="text-gray-600 max-w-3xl mx-auto">
            Making real estate investment accessible to everyone
          </BodyLarge>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative aspect-video rounded-xl overflow-hidden shadow-xl"
        >
          <div style={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe 
              src="https://iframe.mediadelivery.net/embed/375469/e1f0a211-dae1-4649-9acb-dc10d3d66024?autoplay=true&loop=true&muted=true&preload=true&responsive=true"
              loading="lazy"
              style={{ border: 0, position: 'absolute', top: 0, height: '100%', width: '100%' }}
              allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
              allowFullScreen={true}
              title="RentFi Introduction"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}